import { Injectable } from '@angular/core';
import { LocalDbService } from './localDb.service';
import { AlertService } from '../util/alert.service';

@Injectable({
    providedIn: 'root'
})
export class A2hsService {
    deferredPrompt
    showInstallButton = false;
    constructor(private localDb: LocalDbService, private alert: AlertService) {
    }

    installPWA(): void {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then((choiceResult: any) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                    this.localDb.localPost("appInstalled", true);
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                this.deferredPrompt = null;
                this.showInstallButton = false;
            });
        } else {
            this.showAlert();
        }
    }

    showAlert() {
        this.alert.show3ButtonAlert(
            "App Install Concern",
            "Either app is already installed <br>OR " +
            "<br>A2HS (Auto App install) is not supported in your phone. " +
            "<br><br>Manually install Steps" +
            "<ul>" +
            "<li> Click 3 dots of browser setting button</li>" +
            "<li> For Safari- Click share icon</li>" +
            "<li> Select Add to Home Screen Option</li>" +
            "</ul>",
            "Okay", "Hide", "Cancel"
        ).then((value) => {
            if (value == 2) {
                this.alert.showAlert("Hide Button",
                    "No problem, we will try to make it better, And this button will always be available in <br><br>Community / Settings Page").then(() => {
                        this.localDb.localPost("appInstalled", true);
                        this.showInstallButton = false;
                    });
            }
        })
    }

    eventSetup(): void {
        this.localDb.localGet("appInstalled").then((appInstalled) => {
            if (!appInstalled) {
                this.showInstallButton = true;
                window.addEventListener('beforeinstallprompt', (event: any) => {
                    event.preventDefault();
                    this.deferredPrompt = event;
                })
            }
        });
    }


}